import { globalEndpoints } from "../globalEndpoints";
import { mainApi } from "../mainApi";

const path = "v2/support-response";
const name = "SupportResponse";

export const supportApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    // basic global endpoints
    ...globalEndpoints(builder, path, name, []),
  }),
});

export const {
  useGetAllSupportResponseQuery,
  useUpdateSupportResponseMutation,
  useDeleteSupportResponseMutation,
  useGetByIdSupportResponseQuery,
  useCreateSupportResponseMutation,
} = supportApi;
